export enum MinimalCountryAccomodationType {
  Day = 0,
  Month = 1,
}
